import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useOpenableControls } from '../../../generic-hooks'
import { useGlobalConfigContext } from '../../../global-config'
import { priceGetFormattedPrice } from '../../../price'
import { ProductBadge } from '../ProductBadge'
import {
  type ProductPrices,
  useProductPrices,
} from '../ProductBuyBox/hooks/useProductPrices'
import { bonusEnabledPrescriptionTypes } from '../ProductBuyBox/models/bonusEnabledPrescriptionTypes'
import { useProductPageContext } from '../productPageContext'
import { ProductPrescriptionBonusDialog } from '../ProductPrescriptionBonusDialog/ProductPrescriptionBonusDialog'

export const ProductPrescriptionBonusBadge: FC = () => {
  const intl = useIntl()

  const { superScripts } = useGlobalConfigContext()
  const modalControls = useOpenableControls()

  const { currentPrescriptionType, currentVariant, isMasterPage, offerId } =
    useProductPageContext()

  const prices: ProductPrices = useProductPrices({
    currentPrescriptionType,
    offerId,
    product: currentVariant,
  })

  if (
    !bonusEnabledPrescriptionTypes.includes(currentPrescriptionType) ||
    isMasterPage ||
    !prices.displayPrice?.bonus
  ) {
    return null
  }

  return (
    <>
      <ProductBadge<'button'>
        className="relative -mb-4 bg-light-tertiary text-xs"
        data-qa-id="prescription-bonus-badge"
        onClick={modalControls.handleOpen}
        slots={{ root: 'button' }}
        type="button"
      >
        <span className="font-mono font-medium">
          {priceGetFormattedPrice(prices.displayPrice.bonus, intl)}
        </span>
        <span>
          <FormattedMessage id="general.label.bonus" />
          {superScripts.bonus ? <sup>{superScripts.bonus}</sup> : null}
        </span>
      </ProductBadge>
      <ProductPrescriptionBonusDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
